var map = {
	"./ion-action-sheet.entry.js": [
		"6618",
		"chunk-426f2f16"
	],
	"./ion-alert.entry.js": [
		"f06c",
		"chunk-1c4705f4"
	],
	"./ion-app_8.entry.js": [
		"c215",
		"chunk-53b1137a"
	],
	"./ion-avatar_3.entry.js": [
		"cf12",
		"chunk-59d4c87c"
	],
	"./ion-back-button.entry.js": [
		"4b35",
		"chunk-69eb8776"
	],
	"./ion-backdrop.entry.js": [
		"429d",
		"chunk-2d0c073f"
	],
	"./ion-button_2.entry.js": [
		"4453",
		"chunk-25d83ca8"
	],
	"./ion-card_5.entry.js": [
		"070b",
		"chunk-541ea42d"
	],
	"./ion-checkbox.entry.js": [
		"dfd8",
		"chunk-09162720"
	],
	"./ion-chip.entry.js": [
		"430d",
		"chunk-09155df3"
	],
	"./ion-col_3.entry.js": [
		"6a8a",
		"chunk-2d0da04a"
	],
	"./ion-datetime_3.entry.js": [
		"c15b",
		"chunk-21a76241"
	],
	"./ion-fab_3.entry.js": [
		"dd47",
		"chunk-3ed29de3"
	],
	"./ion-img.entry.js": [
		"9588",
		"chunk-2d0e5812"
	],
	"./ion-infinite-scroll_2.entry.js": [
		"d1e5",
		"chunk-2d21da73"
	],
	"./ion-input.entry.js": [
		"d111",
		"chunk-37f2300e"
	],
	"./ion-item-option_3.entry.js": [
		"1bb3",
		"chunk-5ff96a24"
	],
	"./ion-item_8.entry.js": [
		"69da",
		"chunk-5a8ac886"
	],
	"./ion-loading.entry.js": [
		"53a5",
		"chunk-6d375f34"
	],
	"./ion-menu_3.entry.js": [
		"cb00",
		"chunk-097e0872"
	],
	"./ion-modal.entry.js": [
		"1ad0",
		"chunk-1bff95de"
	],
	"./ion-nav_2.entry.js": [
		"e44f",
		"chunk-4739acd0"
	],
	"./ion-popover.entry.js": [
		"4285",
		"chunk-e5275ddc"
	],
	"./ion-progress-bar.entry.js": [
		"9b72",
		"chunk-1dbc15a2"
	],
	"./ion-radio_2.entry.js": [
		"beb3",
		"chunk-0e93a01c"
	],
	"./ion-range.entry.js": [
		"719f",
		"chunk-54bbd082"
	],
	"./ion-refresher_2.entry.js": [
		"0a47",
		"chunk-d8413eac"
	],
	"./ion-reorder_2.entry.js": [
		"6672",
		"chunk-d0e8aa0a"
	],
	"./ion-ripple-effect.entry.js": [
		"c8da",
		"chunk-2d218068"
	],
	"./ion-route_4.entry.js": [
		"10e8",
		"chunk-858cd918"
	],
	"./ion-searchbar.entry.js": [
		"8625",
		"chunk-a9395c36"
	],
	"./ion-segment_2.entry.js": [
		"0c02",
		"chunk-462c869e"
	],
	"./ion-select_3.entry.js": [
		"d25f",
		"chunk-79f1dac7"
	],
	"./ion-slide_2.entry.js": [
		"05dd",
		"chunk-2d0a463b"
	],
	"./ion-spinner.entry.js": [
		"e11b",
		"chunk-8bb7f81e"
	],
	"./ion-split-pane.entry.js": [
		"aae8",
		"chunk-2d213189"
	],
	"./ion-tab-bar_2.entry.js": [
		"a2bb",
		"chunk-02c995b5"
	],
	"./ion-tab_2.entry.js": [
		"6725",
		"chunk-47245a33"
	],
	"./ion-text.entry.js": [
		"ed3b",
		"chunk-30dd9750"
	],
	"./ion-textarea.entry.js": [
		"8798",
		"chunk-eaa2b130"
	],
	"./ion-toast.entry.js": [
		"c1a5",
		"chunk-41c0f7a4"
	],
	"./ion-toggle.entry.js": [
		"bef2",
		"chunk-7548ca2d"
	],
	"./ion-virtual-scroll.entry.js": [
		"5fd7",
		"chunk-2d0d43da"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "aa55";
module.exports = webpackAsyncContext;